export default __webpack_public_path__ + "static/media/oe_3.71a3ab11.mp3";